import { useState, useCallback, useEffect, useMemo } from 'react';
import { Col, ListGroup, Row } from 'react-bootstrap';
import { LuPlus } from 'react-icons/lu';

import { Button, Tag } from '_components/_core';
import { Event, EventDate, EventsContainer, EventsList } from './styles';
import FORMATTERS from 'helpers/formatters';
import { DateTime } from 'luxon';

const EVENT_STATUS = {
  null: 'Pendente',
  PENDING: 'Pendente',
  PROCESSED: 'Processado',
  ERROR: 'Erro',
};

const EVENT_STATUS_COLOR = {
  null: 'warning',
  PENDING: 'warning',
  PROCESSED: 'success',
  ERROR: 'danger',
};

const GatewayWebhooks = ({
  isOpen,
  values,
  onFetchPaymentGatewayWebhooks,
  onCreatePaymentGatewayWebhook,
  onFetchPaymentGatewayWebhookEvents,
}) => {
  const [webhooks, setWebhooks] = useState([]);
  const [webhookEvents, setWebhookEvents] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null);

  useEffect(() => {
    if (!isOpen || !values.id) {
      return;
    }

    onFetchPaymentGatewayWebhooks(values.id, foundWebhooks => {
      setWebhooks(foundWebhooks);
    });
  }, [isOpen, values, onFetchPaymentGatewayWebhooks]);

  const handleCreateWebhook = useCallback(() => {
    onCreatePaymentGatewayWebhook(values.id);
  }, [onCreatePaymentGatewayWebhook, values]);

  const handleFetchWebhookEvents = useCallback(
    webhook_id => {
      onFetchPaymentGatewayWebhookEvents(values.id, webhook_id, foundEvents => {
        setWebhookEvents(foundEvents);
      });
    },
    [onFetchPaymentGatewayWebhookEvents, values],
  );

  const eventsGroupedByDay = useMemo(() => {
    const grouped = webhookEvents.reduce((acc, event) => {
      const date = DateTime.fromISO(event.created_at).toFormat('yyyy-MM-dd');

      if (!acc[date]) {
        acc[date] = [];
      }

      acc[date].push(event);

      return acc;
    }, {});

    return grouped;
  }, [webhookEvents]);

  const handleSelectEvent = useCallback(
    event => {
      if (selectedEvent && selectedEvent.id === event.id) {
        setSelectedEvent(null);

        return;
      }

      setSelectedEvent(event);
    },
    [selectedEvent],
  );

  return (
    <div>
      <h5>Webhooks</h5>
      <Button
        variant="white"
        onClick={handleCreateWebhook}
        className="d-flex align-items-center justify-content-center"
      >
        Criar Webhook
        <LuPlus className="ml-2" />
      </Button>

      <Row>
        <Col>
          <ListGroup className="mt-3">
            {webhooks.map(webhook => (
              <ListGroup.Item key={webhook.id}>
                <div className="d-flex justify-content-between align-items-center">
                  <div className="d-flex align-items-center ">
                    <Tag variant="success">Ativo</Tag>
                    <div>
                      <p className="mb-0 ml-2">{webhook.name}</p>
                    </div>
                  </div>
                  <Button
                    variant="white"
                    onClick={() => handleFetchWebhookEvents(webhook.id)}
                    className="d-flex align-items-center justify-content-center"
                    size="sm"
                  >
                    Ver Eventos
                  </Button>
                </div>
              </ListGroup.Item>
            ))}
          </ListGroup>
        </Col>
      </Row>
      <Row>
        <Col>
          <EventsContainer>
            <EventsList>
              {Object.keys(eventsGroupedByDay).map(date => {
                const events = eventsGroupedByDay[date];

                return (
                  <div key={date}>
                    <EventDate>
                      {DateTime.fromISO(date)
                        .toFormat("dd 'de' MMM. 'de' yyyy")
                        .toUpperCase()}
                    </EventDate>
                    {events.map(event => {
                      return (
                        <div key={event.id}>
                          <Event
                            onClick={() => handleSelectEvent(event)}
                            selected={selectedEvent?.id === event.id}
                            className="d-flex align-items-center justify-content-between"
                          >
                            <div>
                              <Tag
                                variant={EVENT_STATUS_COLOR[event.status]}
                                className="p-0 m-0 pl-2 pr-2"
                              >
                                {EVENT_STATUS[event.status]}
                              </Tag>
                            </div>
                            <div className="ml-3 text-left">
                              {FORMATTERS.MAX_X_CHARS(JSON.stringify(event.payload), 80)}
                            </div>
                            <div>{FORMATTERS.DATE_HHMMSS(event.created_at)}</div>
                          </Event>
                        </div>
                      );
                    })}
                  </div>
                );
              })}
            </EventsList>
          </EventsContainer>
        </Col>
      </Row>
      <Row>
        <Col>
          {selectedEvent && (
            <div>
              <h5>Evento selecionado</h5>
              <pre>{JSON.stringify(selectedEvent, null, 2)}</pre>
            </div>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default GatewayWebhooks;
